import React from "react";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { addLocationMasterAsync } from "../../../../redux/features/location-master/addLocationMasterSlice";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import RouteNames from "../../../../AppRoutes/RouteName";

const LocationSchema = Yup.object().shape({
   name: Yup.string()
      .min(3, "Too Short!")
      .max(50, "Too Long!")
      .required("Location Name is required"),
});

export default function LocationMasterAdd() {
   const dispatch = useDispatch();
   const navigate = useNavigate();

   const formik = useFormik({
      initialValues: {
         name: "",
      },

      validationSchema: LocationSchema,

      onSubmit: (values) => {
         dispatch(backdropLoadingAction(true));
         const bodyData = {
            name: values.name,
            model_id: "10",
            action_id: "1",
         };
         dispatch(
            addLocationMasterAsync({
               data: bodyData,
               done: () => {
                  formik.resetForm();
                  dispatch(backdropLoadingAction(false));
                  toast.success("Location added successfully.");
                  navigate(RouteNames.LocationMasterView);
               },
               err: () => {
                  dispatch(backdropLoadingAction(false));
                  //toast.error("Failed to add location.");
               },
            }),
         );
      },
   });

   const { getFieldProps, handleSubmit, touched, errors } = formik;

   return (
      <div>
         <BodyHeader title="Add Location Master" />
         <div className="p-3 shadow-lg">
            <div className="row">
               <div className="col-lg-12">
                  <div className="card card-primary">
                     <div className="card-header">
                        <h3 className="card-title">Location Master Details</h3>
                     </div>
                     <div className="card-body">
                        <div className="row">
                           <div className="col-12 col-sm-12 col-md-6">
                              <CustomInput
                                 require
                                 label="Name"
                                 id="personName"
                                 placeholder="Enter Location Name"
                                 {...getFieldProps("name")}
                                 errors={touched.name && errors.name}
                                 message={errors.name}
                              />
                           </div>
                           <div className="col-lg-12 mt-3 text-center">
                              <button
                                 className="btn btn-primary px-4 py-3"
                                 type="submit"
                                 onClick={handleSubmit}
                              >
                                 <h6 className="mb-0 text-uppercase">Submit</h6>
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
